// removed by extract-text-webpack-plugin
module.exports = {"Tabs":"Tabs__Tabs__1M8-3"};